import { put, select } from 'redux-saga/effects'
import { playNotificationSound, sendBrowserNotification } from '@/components/ChatSidebar/helpers'
import { ChatState } from '../../types'

import { updateChatAction } from '../../actions'
import { ApplicationState } from '@/redux/store'
import { boldText } from '@/helpers/string.helpers'
import { getMessageText } from '@/components/ChatSidebar/components/Chat/helpers'
import { ChatModel } from '@/models/chat.model'
import { delay } from '@/redux/department/sagas/setDepartmentSaga/helpers'

export function* handleUpdateChatSaga(action: ReturnType<typeof updateChatAction.request>) {
  const { openChats, inProgressChats, finishedChats, activeChat }: ChatState = yield select(
    (state: ApplicationState) => state.chatReducer
  )
  const chat = action.payload.chat

  let findedChat: ChatModel = {} as ChatModel
  if (chat.status === 'open') {
    findedChat = openChats.find(c => c.id === chat?.id)
  }
  if (chat.status === 'in_progress') {
    findedChat = inProgressChats.find(c => c.id === chat?.id)
  }
  if (chat.status === 'close') {
    findedChat = finishedChats.find(c => c.id === chat?.id)
  }

  const chatLastMessage = chat?.lastMessage?.messageId ? chat?.lastMessage : (chat?.lastMessage as any)?.newMessage
  const chatFindedLastMessage = findedChat?.lastMessage || (findedChat?.lastMessage as any)?.newMessage

  const fromMe = chatLastMessage?.fromMe

  const chatStatus = chat?.status

  const isDifferentLastMessage = chatFindedLastMessage?.messageId !== chatLastMessage?.messageId

  const isValidChat =
    chat?.id !== activeChat?.id &&
    chatStatus !== 'close' &&
    !fromMe &&
    !!chat?.unreadMessagesCount &&
    isDifferentLastMessage

  if (isValidChat && findedChat?.id) {
    playNotificationSound()
    yield delay(1000)
    sendBrowserNotification({
      title: chat.chatName,
      body: boldText(
        getMessageText(chatLastMessage) ||
          chatLastMessage?.messageText ||
          chatLastMessage?.buttonResponseMessage?.button?.text ||
          chatLastMessage?.messages?.[0]?.interactive?.button_reply?.title
      ),
      icon: chat?.requesterPhoto || 'https://storage.googleapis.com/bucket-chat-devzapp/devchat-logo/logo.svg'
    })
  }

  yield put(updateChatAction.success({ chat }))
}
